export default __webpack_public_path__ + "static/media/input-by-text-docx-pdf.822a5433.svg";